// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"126":"a3510d83","679":"96a2ba44","871":"1a4a8604"}[chunkId] + ".css";
};